module.exports = __webpack_public_path__ + "static/media/pills.e86f5dc2.svg";